module.exports = __webpack_public_path__ + "static/Playground-5f039cb0243e12e292ebc77a1d21bff6.mp4";